import { createContext } from 'react';
import { SideDrawerContextProps } from './types';

const defaultContextValue: SideDrawerContextProps = {
  openSideDrawer: () => {
    return;
  },
  closeSideDrawer: () => {
    return;
  },
};

const SideDrawerContext =
  createContext<SideDrawerContextProps>(defaultContextValue);

export default SideDrawerContext;
